var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2622 1712",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    opacity: 0.1,
    transform: "translate(0 -7.19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m671.83 304.19c-18.73-177.41 284.38-313.42 402.32-237.49 136.9 88.14 7.26 247.14-74.68 276.66-76.77 27.64-5.47 73.34-65.61 157.53-52.28 73.11-252.19-103.46-262.03-196.7z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1188.43 478.6c-40.81 49.65-67.73 149.26-138.29 100.51-52.34-36.11-55.14-138.81-12.82-199.8s126.89-97.71 186.68-50.9c41.8 28.89 2.75 103.59-35.57 150.19z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m542.5 470.08c32.11-44.74 104.94-94.85 129-57.2 49.92 78.2 73.34-24.25 137.18-20.59s25.22 59.31 99 79.42 57.86 142.07-12.38 119.29-62.3 25.37-97.81 37.86-36.11-34.35-91.9-19.66c-54.87 14.45-133 41-172.15 8.59-31.88-26.36-24.64-100.74 9.06-147.71z",
    fill: "#172b4d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1625.43 1044.8c-81.88 113.13-177.67-22.51-255.26-94.6s-115.64-251.81 26.73-310.64c97.86-40.44 150.43 17.08 228 89.17s74.47 213.93.53 316.07z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1200 1043.51c1.68 47.58-68.8 132.8-119 134.62s-92.26-35.28-94-82.86 37.58-87.61 87.76-89.42 123.49-9.91 125.24 37.66z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m539.44 1645.35c-53.62 68.12-112.25 105.18-196.65 39.49s-75.46-150.94-21.85-219.06 218.74-35 303.14 30.66-31.03 80.75-84.64 148.91z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 919.64c57 74.49 5.73 335.15-127.45 379.36-154.55 51.31-227.46-292.53-216.47-373.31s32.13-87.41 120.92-34.09 166-46.41 223 28.04z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m735 804.87c5.94 91.64 91.12 82 65.06 133.94-21.48 42.84-165.92 241.9-229.06 154.38-31.72-43.94-8.83-84.15-13.86-138.12-6-63.64-90.55-135.71-44.44-179.88 48.46-46.52 217.95-37.36 222.3 29.68z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m410 833.46c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 833.46c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 833.46c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 833.46c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 833.46c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 833.46c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 846.05c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 846.05c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 846.05c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 846.05c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 846.05c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 846.05c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 858.65c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 858.65c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 858.65c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 858.65c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 858.65c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 858.65c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 858.65c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 858.65c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 871.25c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 871.25c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 871.25c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 871.25c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 871.25c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 871.25c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 871.25c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 883.85c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 883.85c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 883.85c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.34 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 883.85c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 883.85c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 883.85c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.34 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 883.85c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 896.45c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 896.45c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 896.45c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 896.45c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 896.45c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 896.45c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 896.45c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 909.05c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 909.05c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 909.05c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 909.05c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 909.05c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 909.05c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 909.05c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 921.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 921.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 921.65c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 921.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 921.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 921.65c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 921.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 934.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 934.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 934.25c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 934.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 934.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 934.25c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 934.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 934.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 946.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 946.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 946.85c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.34 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 946.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 946.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 946.85c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.34 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 946.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 946.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 959.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 959.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 959.45c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 959.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 959.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 959.45c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 959.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 959.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 972.05c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 972.05c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 972.05c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 972.05c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 972.05c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 972.05c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 972.05c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 984.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 984.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 984.65c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 984.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 984.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 984.65c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 984.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 984.65c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 997.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 997.25c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 997.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 997.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 997.25c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 997.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 997.25c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 1009.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 1009.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 1009.85c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.34 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 1009.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 1009.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 1009.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 1009.85c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.34 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 1022.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.47 1022.45c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 1022.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 1022.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 1022.45c0 1.64-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 1022.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 1022.45c0 1.64-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410 1035c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.4 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.71 1035c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.4 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.22 1035c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.4 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m465 1035c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.4 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m478.73 1035c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.4 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.48 1035c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.4 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m506.23 1035c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.66 2.4 3.66 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1324.21 1350.33c68.44 60.27-27.54 191.86-151.71 191.86-56.07 0-139.8-54.33-129.66-118 8.8-55.25 109.61-37.34 140.69-83.88 99.63-149.2 99.29-26.44 140.68 10.02z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1815.78 325.81c122.49-54.62 115.32 78.12 152.52 162.29 97 219.36-354.62 277.55-292.12 187.26s-40.94-129.7-150.58-129.7c-186.25 0-124.6-294.37 61.94-233.07 100.46 33.02 105.74 67.8 228.24 13.22z",
    fill: "#dd234b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1693.74 198.54c50.79-34.57 120.34-.5 154.78 37s-44.41 63.65-86.31 86.1c-30.07 16.12-68.3 17.13-82.81-8.32s-36.4-80.2 14.34-114.78z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2037.41 403.19c-27.51 38.41-164.09 58.77-202.35 31.35s.27-109.35 27.78-147.8 88.93-70.74 127.16-43.34 74.92 121.41 47.41 159.79z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1575.37 1135.08c9.73-83.41 61.88-146.49 130.91-170.66 43.41-15.19 183.57-12.08 250.46 65.42 93.26 108.13 3.55 183.45-94.63 171.35-135.19-16.64-17.08 102.39-103.89 178.48-68.83 60.31-52-51.91-134.47-84.62-60.75-24.05-55.95-95.15-48.38-159.97z",
    fill: "#dd234b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2084.59 1254.53c19 43.06-25.08 132-102.38 132.66s-146-79.34-165.07-122.4 52.34 5.42 117.09-30.78 131.3-22.54 150.36 20.52z",
    fill: "#fb6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1400.15 1576.91c-14.57 11.43-44 15.44-55.38.93s-.56-42.06 14-53.48a33.44 33.44 0 1 1 42 52l-.69.55z",
    fill: "#2dce89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1904.08 952.88c-9 7-27.1 9.48-34.14.57s-.34-25.84 8.64-32.86a20.74 20.74 0 0 1 29 3.44 20.47 20.47 0 0 1 -3.39 28.76z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1616.92 1206.59c16.83-10.45 37.82-1.11 48.35 15.59s27.84 51.49-7 50c-27.09-1.18-82.99-39.72-41.35-65.59z",
    fill: "#5e72e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2392 919.63c-93.41-38.86-455.67-14.67-407.62-130.23s214.31-249.21 307.73-210.34 372.42 94.79 324.37 210.34-131.07 169.09-224.48 130.23z",
    fill: "#ffd049"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 509.63c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.37 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1929.47 509.63c0 1.65-2 3-3.68 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.68 2.37 3.68 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.23 509.63c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.37 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1957 509.63c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.37 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 522.24c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1929.47 522.24c0 1.65-2 3-3.68 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.68 2.36 3.68 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.23 522.24c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1957 522.24c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 534.85c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.39 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1929.47 534.85c0 1.65-2 3-3.68 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.68 2.39 3.68 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.23 534.85c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.39 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1957 534.85c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.39 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 547.47c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1929.47 547.47c0 1.65-2 3-3.68 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.68 2.36 3.68 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.23 547.47c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1957 547.47c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 560.08c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1929.47 560.08c0 1.65-2 3-3.68 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.68 2.36 3.68 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.23 560.08c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 572.7c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.66 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1929.47 572.7c0 1.65-2 3-3.68 3a3 3 0 0 1 -3-3c0-1.66 1.33-4 3-4s3.68 2.35 3.68 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.23 572.7c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.66 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1957 572.7c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.66 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 585.32c0 1.63-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.66 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1929.47 585.32c0 1.63-2 3-3.68 3a3 3 0 0 1 -3-3c0-1.66 1.33-4 3-4s3.68 2.35 3.68 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1957 585.32c0 1.63-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.66 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 597.92c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.32 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1929.47 597.92c0 1.65-2 3-3.68 3a3 3 0 0 1 -3-3c0-1.65 1.33-4 3-4s3.68 2.32 3.68 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.23 597.92c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.32 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1957 597.92c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.32 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 610.54c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.67 2.35 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.23 610.54c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1957 610.54c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.65 1.34-4 3-4s3.66 2.35 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 623.14c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.63 1.34-4 3-4s3.67 2.37 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.23 623.14c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.63 1.34-4 3-4s3.66 2.37 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1957 623.14c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.63 1.34-4 3-4s3.66 2.37 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1915.69 635.76c0 1.65-2 3-3.67 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.67 2.36 3.67 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1929.47 635.76c0 1.65-2 3-3.68 3a3 3 0 0 1 -3-3c0-1.64 1.33-4 3-4s3.68 2.36 3.68 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1943.23 635.76c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1957 635.76c0 1.65-2 3-3.66 3a3 3 0 0 1 -3-3c0-1.64 1.34-4 3-4s3.66 2.36 3.66 4z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m241.75 422.61c-93.67-38.95-282.18-5.17-234-121s283.06-328.67 376.72-289.73 130.53 164.4 82.37 280.21-131.42 169.46-225.09 130.52z",
    fill: "#dd234b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1088.92 1254.59c16.83-10.45 37.82-1.11 48.35 15.59s27.84 51.49-7 50c-27.09-1.18-82.99-39.72-41.35-65.59z",
    fill: "#79cfcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1738.92 833.59c16.83-10.45 37.82-1.11 48.35 15.59s27.84 51.49-7 50c-27.09-1.18-82.99-39.72-41.35-65.59z",
    fill: "#2c3551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1207.85 1181.89c19.33 0 40.28-29 40.28-41.67s-25.8-13-45.13-13-35 10.3-35 23 20.52 31.67 39.85 31.67z",
    fill: "#2c3551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m773.85 1077.89c19.33 0 40.28-29 40.28-41.67s-25.8-13-45.13-13-35 10.3-35 23 20.52 31.67 39.85 31.67z",
    fill: "#79cfcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1161.15 868.19c22 19.85 75.71 8.32 88.76-6.18s-16-41.37-38.08-61.22-50.51-24.2-63.56-9.71-9.17 57.24 12.88 77.11z",
    fill: "#2c3551"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.61576e3fd7ae7f47339cbb6781a518fe.svg";
export { ForwardRef as ReactComponent };